import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import { Spinner as SpinnerIcon } from '../../icons';

import styles from './Loader.module.scss';
import { useCustomizationParams } from '../../context/ViewerContext';

export interface LoaderProps {
  visible: boolean;
  loadingText?: string;
}

const Loader: React.FC<LoaderProps> = (props) => {
  const [loaderImgCustom, setLoaderImgCustom] = useState<string | null>(null);
  const { customizationParams } = useCustomizationParams();
  const { REACT_APP_CUSTOMIZATION_BASE_URL } = process.env;

  useEffect(() => {
    if (customizationParams) {
      setLoaderImgCustom(customizationParams.loader_img);
    }
  }, [customizationParams]);

  return (
    <div
      data-testid='loader'
      className={classNames(styles.ff_loader_overlay, {
        [styles.ff_loader_overlay_hide]: !props.visible,
      })}
    >
      {customizationParams && (
        <>
          <div
            className={classNames(styles.ff_loader, {
              [styles.ff_loader_custom]: loaderImgCustom,
            })}
          >
            {loaderImgCustom ? <img src={REACT_APP_CUSTOMIZATION_BASE_URL + loaderImgCustom} alt='loading configurator' /> : <SpinnerIcon />}
          </div>
          {props.loadingText && <span className={styles.ff_loader_loadingText}>{props.loadingText}</span>}
        </>
      )}
    </div>
  );
};

export default Loader;
